import LevelIndicator from './level-indicator.element.js';

export default LevelIndicator;

LevelIndicator.define('wje-level-indicator', LevelIndicator);
